import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocAlertIssueSyncingCreateRoute: InvariantJiraRoute = {
	name: 'eoc-alert-issue-syncing-create',
	path: '/jira/settings/products/ops/syncs/create',
	exact: true,
};
